=<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <Sidebar></Sidebar>

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container">
                <div class="dashboard-content-inner" >

                    <!-- Dashboard Headline -->
                    <div class="dashboard-headline hidden-xs">
                        <h3>{{$router.currentRoute.meta.title}}</h3>
                    </div>
                      

                    <!-- Row -->
                    <div class="row">
                        <form method="post" v-on:submit.prevent="submit" novalidate="" autocomplete="off">

                            <!-- Dashboard Box -->
                            <div class="col-xl-12">
                                <div class="dashboard-box margin-top-0">

                                    <!-- Headline -->
                                    <div class="headline">
                                        <h3><i class="material-icons">info</i> Informações gerais</h3>
                                    </div>

                                    <div class="content with-padding padding-bottom-0">

                                        <div class="row">

                                            <div class="col-xl-6 col-md-9 col-lg-9">
                                                <div class="submit-field">
                                                    <h5>Nome:</h5>
                                                    <input type="text" class="with-border" placeholder="Informe o nome..." v-model="form.nome">
                                                </div>
                                            </div>

                                            <div class="col-xl-6 col-md-8 col-lg-8">
                                                <div class="submit-field">
                                                    <h5>E-mail:</h5>
                                                    <input type="email" class="with-border" placeholder="Informe o e-mail aqui" v-model="form.email">
                                                </div>
                                            </div>

                                            <div class="col-xl-3 col-lg-3 col-xs-8 col-md-4 col-lg-4">
                                                <div class="submit-field">
                                                    <h5>Telefone:</h5>
                                                    <the-mask :mask="['(##) #####-####','(##) ####-####']"  type="tel" class="with-border" placeholder="(__) _____-____" v-model="form.telefone" />
                                                </div>
                                            </div>
                                            <div class="col-xl-3 col-lg-4 col-xs-7 col-md-4">
                                                <div class="submit-field">
                                                    <h5>CPF</h5>
                                                    <the-mask :mask="['###.###.###-##']" class="with-border" v-model="form.doc" placeholder="000.000.000-00"/>
                                                </div>
                                            </div>

                                            <div class="col-xl-3 col-xs-10 col-md-5 col-lg-5" v-if="$router.currentRoute.name == 'EditarUsuariosGeral' || $router.currentRoute.name == 'CadastrarUsuariosGeral'">
                                                <div class="submit-field">
                                                    <h5>Tipo:</h5>
                                                    <select class="with-border" v-model="form.tipo">
                                                        <option value="" disabled selected hidden>Selecione aqui..</option>
                                                        <option value="admin">Administrador</option>
                                                        <option value="profissional">Profissional</option>
                                                        <option value="marketing">Marketing</option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div class="col-xl-12"></div>

                                            <div class="col-xl-3 col-lg-3 col-xs-8 col-md-4 col-lg-4" v-if="form.tipo == 'profissional'">
                                                <div class="submit-field">
                                                    <h5>WhatsApp da secretária responsável:</h5>
                                                    <the-mask :mask="['(##) #####-####','(##) ####-####']"  type="tel" class="with-border" placeholder="(__) _____-____" v-model="form.whatsapp" />
                                                </div>
                                            </div>

                                            <div class="col-xl-3 col-lg-3 col-xs-7 col-md-4">
                                                <div class="submit-field margin-bottom-20">
                                                    <h5>Código no Tasy</h5>
                                                    <input type="number" class="with-border margin-bottom-5" placeholder=".." v-model="form.codigoIntegracao">
                                                    <small style="line-height: 120%;" class="block">Código do usuário no Tasy, campo necessário para integração.</small>
                                                </div>
                                            </div>                                             
                                      
                                            <div class="col-xl-12 col-xs-12 col-md-12" v-if="form.tipo == 'profissional'">
                                                <div class="submit-field margin-bottom-20">
                                                    <h5>Registro de classe</h5>
                                                    <input type="text" class="with-border margin-bottom-5" placeholder="...." v-model="form.descricao">
                                                    <small style="line-height: 120%;" class="block">Será mostrado aos pacientes quando visualizarem a agenda.</small>
                                                </div>
                                            </div>                                
                                            <div class="col-xl-12 col-xs-12 col-md-12" v-if="form.tipo == 'profissional'">
                                                <div class="submit-field margin-bottom-20">
                                                    <h5>Texto sobre dias e horários de atendimento</h5>
                                                    <textarea class="with-border margin-bottom-5" style="min-height: 70px;" v-model="form.horarioAtendimento" name="horarioAtendimento"></textarea>
                                                    <small style="line-height: 120%;" class="block">Será mostrado aos pacientes quando visualizarem a agenda.</small>
                                                </div>
                                            </div>
                                            <div class="col-xl-12 col-xs-12 col-md-12" v-if="form.tipo == 'profissional'">
                                                <div class="submit-field margin-bottom-20">
                                                    <h5>Especialidade(s)</h5>
                                                    <input type="text" class="with-border margin-bottom-5" placeholder="...." v-model="form.categorias">
                                                    <small style="line-height: 120%;" class="block">Será mostrado aos pacientes quando visualizarem a agenda.</small>
                                                </div>
                                            </div>                                            

                                            <div class="col-xl-4 col-xs-7 col-md-4" v-if="form.tipo == 'profissional'">
                                                <div class="submit-field margin-bottom-20">
                                                    <h5>Ordenação na lista de profissionais</h5>
                                                    <input type="number" class="with-border margin-bottom-5" placeholder=".." v-model="form.ordenacao">
                                                    <small style="line-height: 120%;" class="block">Ordem que aparecerá na agenda.</small>
                                                </div>
                                            </div>   

                                            <div class="col-xl-12">
                                                <div class="submit-field margin-bottom-10">
                                                    <h5>Imagem de perfil</h5>
                                                </div>
                                                
                                                <avatar-cropper
                                                    @submit="submitAvatar"
                                                    @uploading="uploadAvatar"
                                                    :labels="{ 'submit': 'Ok', 'cancel': 'Cancelar'}"
                                                    :upload-handler="uploadAvatar"
                                                    :cropper-options="{'aspectRatio': 0}"
                                                    trigger="#avatar-imagem" />

                                                <div class="avatar-wrapper margin-top-0" style="float: left">
                                                    <div class="img" id="avatar-imagem" v-if="form.imagem" :style="{'background-image': 'url(' + form.imagem + ')'}"></div>
                                                </div>
                                               
                                            </div>          
                                            <div class="col-xl-12 margin-bottom-20" v-if="form.tipo == 'profissional'">
                                                <div class="checkbox">
                                                    <input type="checkbox" id="mostrar-agenda" true-value="1" false-value="0" v-model="form.mostrarAgenda">
                                                    <label for="mostrar-agenda"><span class="checkbox-icon"></span> Habilitar agendamento de consultas pelo aplicativo para esse profissional.</label>
                                                </div>            
                                            </div>    

                                            <div class="col-xl-12 margin-bottom-20" v-if="form.tipo == 'profissional'">
                                                <div class="checkbox">
                                                    <input type="checkbox" id="notificacoes-agenda" true-value="1" false-value="0" v-model="form.notificacoesAgenda">
                                                    <label for="notificacoes-agenda"><span class="checkbox-icon"></span> Habilitar o envio de confirmações e lembretes para agendamentos deste profissional.</label>
                                                </div>                                                                              
                                            </div>     


                                            <div class="col-xl-12 margin-bottom-20" v-if="form.email != ''">
                                                <div class="submit-field margin-bottom-10">
                                                    <h5>Deseja enviar um e-mail com a senha de acesso gerada pelo sistema?</h5>
                                                </div>
                                                <div class="checkbox">
                                                    <input type="checkbox" id="email-enviar" true-value="1" false-value="0" v-model="form.emailEnviar">
                                                    <label for="email-enviar"><span class="checkbox-icon"></span> Enviar e-mail</label>
                                                </div>                                                                              
                                            </div>                                                                                  

                                            <div class="col-xl-12 clearfix"></div>


                                            <!-- Button -->
                                            <div class="col-xl-12 margin-bottom-30">
                                                <!-- <small class="help" v-show="$router.currentRoute.name == 'CadastrarUsuariosContratante' || $router.currentRoute.name == 'CadastrarUsuariosGeral'">Após o cadastro, o usuário receberá no e-mail acima uma senha de acesso gerada pelo sistema.</small> -->
                                                <button type="submit" class="button green block-mobile" v-bind:class="{'disabled': loading.submit }">
                                                    <i class="material-icons">save</i>
                                                    Salvar
                                                </button>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                            </div>

                        </form>
                    </div>
                </div>
            </div>
        </div>
        <Toolbar></Toolbar>

    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'
import AvatarCropper from "vue-avatar-cropper"

export default {
    name: 'GerenciarUsuarios',
    components: {
        'Top':                      Top,
        'Sidebar':                  Sidebar,
        'Toolbar':                  Toolbar,
        'AvatarCropper':            AvatarCropper
    },       
    data () {
        var self                    = this;
        return {
            "loading": {
                "submit":           false
            },
            "empresas": {
                "itens":            []
            },
            "form": {
                "_cod":             "",
                "_token":           "",
                "nome":             "",
                "tipo":             "",
                "email":            "",
                "telefone":         "",
                "whatsapp":         "",
                "empresaCod":       "",
                "codigoIntegracao": "",
                "ordenacao":        "",
                "mostrarAgenda":    "",
                "notificacoesAgenda":    "",
                "imagem":           "https://clientes.negociar.org/images/avatar.png",
                // "dataNascimento":   "",
                // "doc":              ""
            }            
        }
    },
    watch: {
        "form.tipo": function(val) {
            var self = this;
            console.log("watch form.tipo", val)
            if (val == "profissional" && self.form.ordenacao == "") {
                if (self.ordenacao) {
                    self.form.ordenacao = parseInt(self.ordenacao) + 100;
                    self.$forceUpdate(); 
                }
            }
        }
    },
    methods: {
        submitAvatar: function(e) {
            var self = this;
            console.log("submitAvatar()", e)
            loading.show();
        },    
        uploadAvatar: function(e) {
            var self = this;
            console.log("uploadAvatar()", e)
            loading.show();
            // self.form.imagem = e.getCroppedCanvas().toDataURL();
            e.getCroppedCanvas().toBlob((blob1) => {
                reduceFileSize(blob1, 500*1024, 1000, Infinity, 0.9, blob2 => {
                    blobToBase64(blob2, function(result) {
                        setTimeout(function() {
                            loading.hide();
                        }, 500);
                        self.form.imagem    = result;
                        self.$forceUpdate();
                    });
                });             
            });
            return true;
        },          
        submit: function(e) {
            var self            = this;
            self.form._cod      = self.$root.user.cod;
            self.form._token    = self.$root.user.token;
            console.log("submit()", e, self.form, JSON.stringify(self.form));
            e.preventDefault();
            self.loading.submit = true;
            loading.show();
                
            var a = "post";
            if (self.form.cod) {
                a = "put";
            }

            console.log("acao", a);

            axios[a]("api/usuarios.php", self.form)
            .then(response => {
                
                self.loading.submit = false;
                console.log("submit() response", response)
                loading.hide();
                alert(response.data.message);
                self.$root.tmp  = {
                    "tipo":     "GerenciarUsuarios",
                    "valor":    response.data.result
                };
                self.$root.back();
                
            })
            .catch(error => {
                console.log("submit() error", error)
                loading.hide();
                self.loading.submit = false;
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
            });

        },
        getOrdenacao: function() {
            var self        = this;
            console.log("getOrdenacao()");
            // loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "tipo":         "ordenacao"
                    }
                };

                axios.get("api/usuarios.php", form)
                .then(response => {
                    
                    console.log("getOrdenacao() response", response);
                    self.ordenacao     = response.data.result ? response.data.result.ordenacao : 0;
                    // loading.hide();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("getOrdenacao() error", error);                    
                    // loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                    if (error.response) {
                       
                    }                    
                });   
            });   
        },
        get: function() {
            var self        = this;
            console.log("get()", self.form);
            loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "cod":          self.form.cod
                    }
                };

                axios.get("api/usuarios.php", form)
                .then(response => {
                    
                    console.log("get() response", response);

                    var d               = response.data.result.dataNascimento.split("-");
                    response.data.result.dataNascimento = d[2] + "/" + d[1] + "/" + d[0];
                    self.form           = response.data.result;
                    self.loaded         = true;
                    loading.hide();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                    if (error.response) {
                        if (error.response.status == 404) {
                            self.$root.back();
                        }
                    }                    
                });   
            });   
        }
    },    
    created: function() {
        var self = this;
        console.log("created", self);

        if (self.$route.name == "EditarUsuariosGeral" || self.$route.name == "EditarUsuariosContratante") {
            if (!self.$route.query.c) {
                self.$root.back();
                return false;
            }
            self.form.cod = self.$route.query.c;
            self.get();
        } else {
            loading.hide();
        }


        if (self.$route.name == "CadastrarUsuariosGeral") {
            self.getOrdenacao();
        }
    },
    mounted: function() {
    }     
} 
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/GerenciarUsuarios.vue